import tw, { styled } from 'twin.macro';

const MarkdownUnorderedList = styled.ul`
  .message-type-markdown & {
    ${tw`my-0`}
    padding-left: 1rem;
  }
`;

export default MarkdownUnorderedList;
